module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.data.length == 1) ? _c('div', [_c('p', {
    staticClass: "price has-text-right"
  }, [_vm._v("\n      " + _vm._s(_vm.data[0].text) + "\n    ")])]) : _vm._l((_vm.data), function(price) {
    return _c('div', [(price.type == 2) ? _c('p', {
      staticClass: "price has-text-right"
    }, [_vm._v("\n      " + _vm._s(price.text) + "\n    ")]) : _vm._e(), _vm._v(" "), (price.type == 1) ? _c('p', {
      staticClass: "price discount has-text-right"
    }, [_vm._v("\n      " + _vm._s(price.text) + "\n    ")]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2daa3f6","hasScoped":true}!./src/components/price/template.html
// module id = 421
// module chunks = 1